export default "__VITE_ASSET__UCxvum6I__"